import type { VisibleArea, VisibleModule } from '@portal/contracts';

export interface Location {
  area: VisibleArea | null;
  module: VisibleModule | null;
}

/** Aktives Modul = längster passender Pfad (z. B. /kunden/loyalty vor /kunden) */
export function resolveLocation(areas: readonly VisibleArea[], pathname: string): Location {
  let best: { area: VisibleArea; module: VisibleModule } | null = null;
  for (const area of areas) {
    for (const m of area.modules) {
      const hit = m.path === '/' ? pathname === '/' : pathname === m.path || pathname.startsWith(`${m.path}/`);
      if (hit && (!best || m.path.length > best.module.path.length)) best = { area, module: m };
    }
  }
  return best ?? { area: null, module: null };
}
